import { render, staticRenderFns } from "./imgSlider.vue?vue&type=template&id=7a517421&scoped=true"
import script from "./imgSlider.vue?vue&type=script&lang=js"
export * from "./imgSlider.vue?vue&type=script&lang=js"
import style0 from "./imgSlider.vue?vue&type=style&index=0&id=7a517421&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a517421",
  null
  
)

export default component.exports